import { useInternet } from "../../../../hooks/useInternet.js";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { SimpleField } from "../../../../components/fields/simpleField.jsx";
import { useResource } from "../../../../hooks/useResource.js";
import { Button } from "../../../../components/button.jsx";

export function Step3({ setStep }) {
  let internet = useInternet();
  let session = useSelector((state) => state.session);
  let { control, handleSubmit, reset, formState, watch, setValue } = useForm({
    resolver: zodResolver(
      zod.object({
        companyPhone: zod.string().nullish(),
        companyVat: zod.string().nullish(),
        companyBank: zod.string().nullish(),
      })
    ),
    defaultValues: session.account,
  });

  let accountService = useResource("accounts");
  let save = (d) => {
    return accountService.edit("me", d).then(() => setStep(4));
  };

  return (
    <div className={"flex flex-col gap-3 text-center"}>
      <div className={"font-bold"}>
        Give us a few information about your company
      </div>
      <div>
        We will use this data to provide accurate accounting information, help
        you generate documents, ...
      </div>

      <form
        onSubmit={handleSubmit(save)}
        className={"flex flex-col gap-3 bg-white p-3 rounded"}
      >
        <SimpleField name={"companyPhone"} label="phone" control={control} />
        <SimpleField name={"companyVat"} label="vat_number" control={control} />
        <SimpleField
          name={"companyBank"}
          label="bank_number"
          control={control}
        />
        <Button formState={formState} type={"submit"}>
          next
        </Button>
      </form>
    </div>
  );
}
